import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import AppTheme from '../../shared-theme/AppTheme';
import CssBaseline from '@mui/material/CssBaseline';

interface LoadingDataProps {
  open: boolean;
}

export default function LoadingData({open}: LoadingDataProps) {
  return (
    <AppTheme>
      <CssBaseline enableColorScheme />
      <Backdrop
        sx={(theme) => ({ 
          color: theme.palette.primary.main, 
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
          zIndex: theme.zIndex.drawer + 1,
          position: 'absolute' })}
        open={open}
      >
        {/* <MuiCard variant="outlined"> */}
            <CircularProgress color="inherit" size={30} />
        {/* </MuiCard> */}
      </Backdrop>
    </AppTheme>
  );
}